import React, { Component } from 'react';

class Placeholder extends Component {
    render() {
        const classNameSuffix = 'get';
        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 600 }}>
                <img src="/resources/images/iphone-logo128.png" alt="A-POS" style={{ margin: 40 }} />
                <h2>A-POS API</h2>
                <div className={`card card-api get`} style={{ margin: 40 }}>
                    <div className="card-header" onClick={() => { window.open("https://documenter.getpostman.com/view/94053/RWEZQh88", "_self") }}>
                        <div className="mb-0 justify-content-between card-title">
                            <p className="name">{'API Document'}</p>
                            <span className="path">{'https://documenter.getpostman.com/view/94053/RWEZQh88'}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Placeholder;



// WEBPACK FOOTER //
// ./src/views/dashboard/Placeholder.jsx